import React from "react";
import styled from "styled-components";

const TextStyle = styled.div`
    font-size: ${props => props.$fontSize};
    text-align: ${props => props.$textAlign};
    line-height: ${props => props.$lineHeight};
    display: flex;
    >span {
        margin: auto;
    }
`;

export const Text = React.memo(props => {

    const { size, children, className, textAlign = "left" } = props;
    const fontSize = size === "medium" ? "14px" : "12px";
    const lineHeight = size === "medium" ? "18px" : "16px";

    return (
        <TextStyle
            className={className}
            $fontSize={fontSize}
            $textAlign={textAlign}
            $lineHeight={lineHeight}>
            <span>
                {children}
            </span>
        </TextStyle>
    );
});